import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';


const routes: Routes = [
  { path: '', redirectTo: 'welcome', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then( m => m.WelcomePageModule),
    // canLoad: [ AuthGuardService ]
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./pages/change-password/change-password.module').then( m => m.ChangePasswordPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'core-benefits',
    loadChildren: () => import('./pages/core-benefits/core-benefits.module').then( m => m.CoreBenefitsPageModule)
  },
  {
    path: 'complementry-benefits',
    loadChildren: () => import('./pages/complementry-benefits/complementry-benefits.module').then( m => m.ComplementryBenefitsPageModule)
  },
  {
    path: 'benefits-selections',
    loadChildren: () => import('./pages/benefits-selections/benefits-selections.module').then( m => m.BenefitsSelectionsPageModule)
  },
  {
    path: 'success',
    loadChildren: () => import('./pages/success/success.module').then( m => m.SuccessPageModule)
  },
  {
    path: 'complementry-benefits-selections',
    loadChildren: () => import('./pages/complementry-benefits-selections/complementry-benefits-selections.module')
      .then( m => m.ComplementryBenefitsSelectionsPageModule)
  },
  {
    path: 'complementry-benefits-selections-market',
    loadChildren: () => import('./pages/complementry-benefits-selections-market/complementry-benefits-selections-market.module')
      .then( m => m.ComplementryBenefitsSelectionsMarketPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
